import React, { useContext } from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';

import Box from '../../../elements/Box';
import Text from '../../../elements/Text';
import Link from '../../../elements/Link';

const FareItemHotelName = (props) => {
  const { hotelName, hotelNameStyle, renderAs = 'text', id } = props;
  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  return (
    <Box
      className={`fare-item-hotel-name ${className}`}
      style={style}
      role="heading"
      ariaLevel={3}
      id={id}
    >
      {renderAs === 'text' ? (
        <Text {...hotelNameStyle}>{hotelName}</Text>
      ) : (
        <Link {...hotelNameStyle}>{hotelName}</Link>
      )}
    </Box>
  );
};

FareItemHotelName.defaultProps = {
  hotelName: '',
  hotelNameStyle: {}
};

FareItemHotelName.componentName = 'FareItemHotelName';

export default FareItemHotelName;
